import { Ref, forwardRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@sentry/react';
import { Alert, Box } from '@mui/material';

import { isDevEnv } from '../../helpers/functions/env';
import ErrorElement from '../ErrorElement';

const PageLayout = (_props: unknown, ref: Ref<unknown>) => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary fallback={<ErrorElement />}>
      <Box
        ref={ref}
        sx={{
          padding: { xs: 1, sm: 2 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          width: 1,
        }}
      >
        {isDevEnv() && (
          <Alert
            severity="warning"
            variant="filled"
            sx={(theme) => ({
              width: {
                xs: `calc(100% + ${theme.spacing(2)})`,
                sm: `calc(100% + ${theme.spacing(4)})`,
              },
              zIndex: 1,
              borderRadius: 0,
              boxSizing: 'border-box',
              mt: { xs: -1, sm: -2 },
            })}
          >
            {t('dev-notification')}
          </Alert>
        )}
        <Outlet />
      </Box>
    </ErrorBoundary>
  );
};

export default forwardRef(PageLayout);
